export const GET_PROSPECTUS = "GET_PROSPECTUS";
export const SET_PROSPECTUS = "SET_PROSPECTUS";

export const READ_PROSPECTUS = "READ_PROSPECTUS";